import React from "react";

interface Clim6440LogoProps {
  size?: number;
  className?: string;
}

export const Clim6440Logo = React.memo(
  ({ size = 128, className }: Clim6440LogoProps) => (
    <svg
      id="Calque_2"
      data-name="Calque 2"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 404.16 424.32"
      fill="transparent"
      width={size}
      height={size}
      className={className}
    >
      <defs>
        <style>
          {`
      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5, .cls-6, .cls-7, .cls-8, .cls-9, .cls-10, .cls-11, .cls-12, .cls-13, .cls-14, .cls-15, .cls-16, .cls-17, .cls-18, .cls-19, .cls-20, .cls-21, .cls-22, .cls-23, .cls-24, .cls-25, .cls-26, .cls-27, .cls-28, .cls-29, .cls-30, .cls-31, .cls-32, .cls-33, .cls-34 {
        stroke-width: 0px;
      }

      .cls-2 {
        fill: #62577a;
      }

      .cls-3 {
        fill: #774a68;
      }

      .cls-4 {
        fill: #714d6d;
      }

      .cls-5 {
        fill: #7b4763;
      }

      .cls-6 {
        fill: #4d648d;
      }

      .cls-7 {
        fill: #4d658c;
      }

      .cls-8 {
        fill: #516189;
      }

      .cls-9 {
        fill: #5c5a80;
      }

      .cls-10 {
        fill: #81435e;
      }

      .cls-11 {
        fill: #6d5071;
      }

      .cls-12 {
        fill: #9b3347;
      }

      .cls-13 {
        fill: #96364b;
      }

      .cls-14 {
        fill: #a52d3d;
      }

      .cls-15 {
        fill: #585d83;
      }

      .cls-16 {
        fill: #aa2939;
      }

      .cls-17 {
        fill: #af2735;
      }

      .cls-18 {
        fill: #cb151b;
      }

      .cls-19 {
        fill: #bf1c26;
      }

      .cls-20 {
        fill: #d95155;
      }

      .cls-21 {
        fill: #b5232f;
      }

      .cls-22 {
        fill: #d13237;
      }

      .cls-23 {
        fill: #d13136;
      }

      .cls-24 {
        fill: #d13137;
      }

      .cls-25 {
        fill: #8b3d55;
      }

      .cls-26 {
        fill: #903a51;
      }

      .cls-27 {
        fill: #b9202b;
      }

      .cls-28 {
        fill: #c41921;
      }

      .cls-29 {
        fill: #665476;
      }

      .cls-30 {
        fill: #7c8dac;
      }

      .cls-31 {
        fill: #a12f41;
      }

      .cls-32 {
        fill: #864059;
      }
`}{" "}
        </style>
      </defs>
      <g id="Calque_6" data-name="Calque 6">
        <g>
          <path
            className="cls-33"
            d="m.03,246.1C.03,164.45.03,82.8,0,1.15,0,.13.27,0,1.19,0,135.11.03,269.04.03,402.96,0c1.08,0,1.2.3,1.2,1.25-.03,48.76-.02,97.52-.02,146.28-.12.08-.24.07-.34-.03-.13-.15-.22-.33-.29-.52-1.24-2.95-3.57-4.07-6.68-3.19-4.04,1.15-7.98,2.58-11.98,3.85-11.81,3.73-23.57,7.6-35.34,11.42-4.63,1.51-9.25,3.07-13.91,4.5-2.12.65-3.54,1.96-3.89,4.24-.16.5-.21,1.01-.03,1.52.4,2.3,1.68,3.81,3.98,4.38.77.18,1.53.19,2.28-.04,5.79-1.82,11.56-3.73,17.33-5.61,8.73-2.85,17.48-5.67,26.21-8.54,5.81-1.91,11.62-3.78,17.44-5.65,1.94-.62,3.63-1.45,4.52-3.42.12-.27.29-.59.71-.52v124.95c-.55.05-.61-.43-.78-.76-.78-1.49-1.95-2.45-3.57-2.98-6.19-2.02-12.39-4.02-18.59-6.03-.57-.19-1.46-.2-1.48-.97-.02-.65.8-.81,1.32-1.07,2.35-1.19,4.68-2.44,7.01-3.66,2.22-1.16,3.23-3.64,2.57-5.89-.73-2.46-2.87-3.93-5.46-3.75-1.07.07-1.99.58-2.92,1.03-5.36,2.59-10.59,5.44-15.92,8.1-1.2.6-2.28.72-3.54.25-3.6-1.32-7.3-2.35-10.93-3.6-.44-.15-1.06-.17-1.16-.71-.1-.57.45-.9.85-1.21,4.24-3.33,8.47-6.68,12.7-10.03,2.61-2.06,3.49-4.7,2.56-7.38-.83-2.37-2.54-3.7-4.92-4.28-.68-.25-1.37-.21-2.06-.02-1.58.29-2.85,1.13-4.1,2.11-7.97,6.33-15.95,12.65-23.96,18.92-.92.72-1.17,1.43-.85,2.56,2.81,9.99,5.67,19.97,8.41,29.97.82,3,2.51,5.04,5.75,5.47.44.15.88.17,1.32.01,3.26-.48,4.97-2.54,5.75-5.58.2-.52.14-1.03-.04-1.53-1.47-5.43-3.03-10.83-4.56-16.24-.15-.54-.35-1.07-.26-1.64.07-.35.25-.6.63-.66,1.23.16,2.39.62,3.57.98,2.97.93,5.89,2.04,8.89,2.87.94.26,1.45.89,1.86,1.72,2.7,5.52,5.66,10.91,8.34,16.45.4.84.92,1.58,1.6,2.22,1.61,1.49,4.25,1.76,6.11.62,2.02-1.24,2.95-3.69,2.26-5.91-.31-1-.79-1.92-1.31-2.82-1.02-1.76-1.86-3.62-2.78-5.44-.17-.35-.43-.75-.12-1.12.35-.42.82-.2,1.23-.06.91.3,1.85.51,2.75.82,5.21,1.8,10.5,3.34,15.7,5.17,2.98,1.05,6,.34,7.39-2.7.14-.3.28-.69.76-.62,0,48.57,0,97.13.02,145.7,0,.9-.2,1.1-1.1,1.1-66.47-.02-132.94-.02-199.42-.02-.02-.53.46-.61.78-.79,2.11-1.17,2.97-3.02,2.96-5.36,0-6.27-.01-12.54.01-18.81,0-.72-.35-1.78.43-2.07.73-.28,1.24.71,1.77,1.22,1.57,1.53,3.13,3.09,4.66,4.66.95.97,2.03,1.67,3.37,1.94.51.18,1.02.27,1.55.08,2.22-.51,3.7-1.85,4.41-4.02.18-.8.24-1.6-.06-2.39-.44-1.23-1.2-2.23-2.13-3.15-4.31-4.28-8.58-8.59-12.89-12.86-.76-.76-1.12-1.56-1.11-2.64.04-3.91.01-7.83.02-11.74,0-.54-.2-1.25.34-1.55.61-.34,1.11.27,1.59.58,4.34,2.86,8.74,5.63,12.94,8.67,3.99,2.88,9.48,1.28,10.62-3.8.23-.69.21-1.38.03-2.07-.48-2.05-1.65-3.55-3.42-4.71-8.66-5.73-17.3-11.51-25.94-17.27-1.43-.95-1.44-.95-2.86,0-8.65,5.76-17.28,11.53-25.93,17.28-3.08,2.05-3.88,4.8-2.9,7.88,1.25,3.94,5.92,5.42,9.45,3.1,4.57-3.01,9.12-6.06,13.67-9.1.33-.22.65-.46,1.02-.62.44-.19.78-.13.94.38.15,4.6.05,9.21.05,13.81-.04.79-.6,1.27-1.11,1.78-4.48,4.49-8.98,8.96-13.45,13.46-2.45,2.47-2.17,6.05.59,8.12.7.52,1.49.74,2.32.87.43.15.86.16,1.29,0,1.45-.32,2.63-1.08,3.67-2.11,1.77-1.77,3.52-3.56,5.33-5.29.33-.32.8-1.17,1.32-.1.13,4.41.02,8.83.06,13.24.02,2.82-.06,5.64.05,8.46.19,1.96,1.25,3.33,2.94,4.27.26.14.6.27.52.68h-119.91c-.5-.26-.92-.63-1.31-1.02-14.44-14.45-28.88-28.89-43.32-43.33-1.31-1.31-1.31-1.36-.01-2.66,4.69-4.69,9.38-9.38,14.07-14.08q.91-.91-.02-1.85c-11.02-11.02-22.04-22.04-33.06-33.07-.14-.14-.28-.28-.42-.42q-1.55-1.55-.04-3.07c10.43-10.43,20.86-20.86,31.28-31.29.58-.58,1.35-1.05,1.16-2.08-.04-.18.14-.37.28-.52.97-1.01,1.94-2.02,2.98-2.96.18-.16.4-.27.66-.21.31.13.5.39.69.64,1.12,1.55,2.67,2.34,4.53,2.58.5.17.99.16,1.49-.02,2.9-.62,4.65-2.38,5.46-5.24,2.8-10.04,5.6-20.08,8.48-30.1.32-1.12.13-1.82-.81-2.56-8.23-6.46-16.44-12.95-24.64-19.45-1.02-.81-2.15-1.36-3.41-1.68-.62-.21-1.24-.2-1.87-.02-2.89.57-4.8,2.17-5.36,5.16-.18.83-.18,1.65,0,2.48.32,1.6,1.15,2.88,2.42,3.88,4.23,3.34,8.46,6.68,12.69,10.03.45.35,1.2.63,1.07,1.32-.13.68-.93.67-1.47.86-3.66,1.28-7.37,2.39-11.04,3.62-1.02.34-1.92.32-2.87-.21-5.27-2.93-10.8-5.36-16.08-8.28-.35-.19-.71-.37-1.08-.53-3.72-1.56-6.98.77-7.37,3.74-.18.56-.19,1.11-.02,1.67.12.74.41,1.43.62,2.14-.57,1.52-1.15,1.67-2.26.57-3.72-3.7-7.43-7.43-11.15-11.13-.34-.34-.61-.73-.85-1.14Z"
          />
          <path
            className="cls-34"
            d="m52.8,287.83c-1.15,1.11-2.3,2.21-3.44,3.32-.09.08-.24.21-.22.27.58,1.53-.87,1.96-1.57,2.66-10.41,10.49-20.87,20.94-31.35,31.36-.69.69-.74,1.03-.02,1.75,11.44,11.39,22.83,22.82,34.27,34.2.77.77.71,1.12-.02,1.84-4.86,4.8-9.66,9.66-14.53,14.46-.73.72-.79,1.07-.02,1.84,14.6,14.55,29.17,29.13,43.74,43.71.34.34.64.71.95,1.07-26.5,0-53,0-79.5.02-.9,0-1.1-.2-1.1-1.1.02-59.04.02-118.08.02-177.12,2.05,2.01,4.1,4,6.13,6.02,1.98,1.96,3.95,3.94,5.92,5.91q1.05,1.05,2.1-.12c.07-.05.17-.1.21-.06,2.65,2.35,6.01,3.43,9.04,5.12.57.32,1.54.45,1.48,1.19-.06.74-1.04.73-1.65.93-5.87,1.98-11.76,3.88-17.67,5.75-.61.19-1.21.42-1.79.68-2.57,1.13-3.5,3.62-2.78,6.17.71,2.51,3.26,3.95,5.83,3.47.71-.13,1.39-.36,2.07-.59,5.95-1.99,11.92-3.92,17.9-5.81.15-.05.3-.1.46-.14.35-.09.74-.27,1.03.01.35.35.1.75-.07,1.11-1.12,2.44-2.52,4.72-3.68,7.14-.44.92-.72,1.84-.71,2.88.02,2.55,1.38,4.34,3.84,4.97,2.22.57,4.51-.48,5.66-2.6,2.03-3.72,3.9-7.52,5.77-11.32,1.04-2.12,2.25-4.15,3.26-6.28.37-.78.96-1.24,1.78-1.47,3.96-1.13,7.8-2.63,11.76-3.76.45-.13.96-.44,1.36-.04.39.39.11.92-.02,1.36-1.42,5.04-2.83,10.08-4.26,15.12-.49,1.73-.77,3.42-.15,5.17.11.3.19.62-.05.91Z"
          />
          <path
            className="cls-6"
            d="m352.38,285.42c-.75,3.26-2.6,5.37-6.05,5.83-.39.08-.78.09-1.17,0-3.52-.27-5.37-2.66-6.19-5.81-1.11-4.29-2.36-8.54-3.57-12.81-1.1-3.88-2.08-7.8-3.21-11.68-.59-2.02-1.1-4.06-1.72-6.06-.28-.91.1-1.38.67-1.82,4.36-3.41,8.81-6.71,13.09-10.22,3.95-3.25,8.08-6.28,11.98-9.59,1.04-.88,2.26-1.34,3.58-1.59.71-.1,1.43-.12,2.14,0,2.74.7,4.65,2.24,5.31,5.13.62,2.72-.4,5.23-2.79,7.07-4.33,3.35-8.62,6.75-12.91,10.14-.3.24-.67.44-.81.88,4.42,1.46,8.83,2.9,13.24,4.36.53.18.98.02,1.46-.22,5.74-2.93,11.48-5.86,17.22-8.77,2.48-1.25,4.88-1.03,6.66.55,2.87,2.56,2.29,7.12-1.15,8.91-2.79,1.45-5.59,2.88-8.59,4.42,1.57.78,3.11,1.14,4.6,1.62,5.48,1.79,10.97,3.53,16.44,5.35,1.45.48,2.45,1.57,3.06,3,.12.28.17.61.49.76v.24c-.2.64-.2,1.28,0,1.92v.48c-.85,1.1-1.29,2.48-2.62,3.27-1.51.9-3.07,1.09-4.65.59-5.59-1.77-11.14-3.64-16.71-5.46-1.03-.34-2.09-.59-3.12-.94-.25-.08-.47-.18-.64,0-.21.23.06.44.16.63,1.26,2.5,2.59,4.97,3.81,7.49,1.66,3.41.14,6.95-3.37,7.97-2.32.68-5.18-.5-6.24-2.68-2.02-4.13-4.14-8.21-6.28-12.28-.94-1.78-1.83-3.58-2.67-5.4-.31-.67-.74-1.04-1.44-1.21-3.08-.75-5.99-2.01-9.01-2.95-1.11-.34-2.27-.5-3.32-1.02-.59-.23-.71,0-.52.53.32,2.1,1.08,4.09,1.64,6.13,1.08,3.94,2.16,7.89,3.24,11.83.07.47.1.95-.02,1.42Z"
          />
          <path
            className="cls-6"
            d="m185.43,405.41c-3.1-.16-4.89-2.9-4.98-5.28-.05-1.43.47-2.86,1.63-4,4.83-4.74,9.6-9.55,14.38-14.34.1-.1.15-.27.22-.4.18-.25.12-.54.12-.81,0-4.31,0-8.63,0-12.94,0-.27.07-.56-.12-.81-.53-.2-.8.29-1.12.5-4.64,3.06-9.28,6.14-13.87,9.27-3.56,2.43-8.96,1.27-10.22-3.58-.74-2.82-.14-5.5,2.75-7.44,8.94-6.01,17.92-11.97,26.86-17.98.77-.52,1.32-.53,2.11,0,8.95,6,17.92,11.98,26.9,17.94,1.69,1.12,2.65,2.68,3.12,4.61.08.71.08,1.42,0,2.13-1.13,5.32-6.86,7.1-10.9,4.18-1.95-1.41-3.98-2.73-5.98-4.07-2.62-1.75-5.24-3.49-7.87-5.23-.19-.13-.42-.19-.77-.35v1.95c0,3.92.02,7.83-.02,11.75,0,.74.22,1.25.75,1.77,4.26,4.22,8.47,8.48,12.73,12.7,1.11,1.1,2.16,2.21,2.68,3.71.13.87.12,1.75,0,2.62-.74,2.26-2.26,3.65-4.61,4.13-.47.11-.95.11-1.42,0-1.55-.2-2.77-.95-3.85-2.07-1.98-2.06-4.03-4.05-6.27-6.3v1.4c0,6.34-.09,12.68.04,19.02.06,3.24-1.04,5.57-4.08,6.86h-3.12c-.57-.62-1.4-.85-2.04-1.43-.97-.89-1.44-1.91-1.63-3.14-.12-5.54,0-11.09-.06-16.63-.02-1.94.14-3.89-.1-5.83-.49-.05-.65.39-.9.65-1.88,1.85-3.73,3.72-5.59,5.58-1,1-2.17,1.71-3.6,1.92-.39.09-.78.09-1.17,0Z"
          />
          <path
            className="cls-18"
            d="m404.14,149.93s-.1.01-.11.03c-.99,2.6-3.12,3.59-5.61,4.37-8.34,2.63-16.63,5.41-24.95,8.13-6.21,2.03-12.43,4.07-18.65,6.08-5.62,1.82-11.26,3.62-16.88,5.43-.79.07-1.59.11-2.38-.03-2.48-.54-3.73-2.2-4.13-4.6-.1-.47-.1-.95,0-1.42.32-2.31,1.54-3.8,3.82-4.53,14.69-4.75,29.37-9.54,44.06-14.31,5.88-1.91,11.77-3.81,17.67-5.69,3.23-1.03,6.43.89,6.96,4.1.27.55-.1,1.17.22,1.71v.72Z"
          />
          <path
            className="cls-30"
            d="m404.14,277.04c-.35-.64-.38-1.28,0-1.92v1.92Z"
          />
          <path
            className="cls-20"
            d="m404.14,149.21c-.45-.52-.17-1.14-.22-1.71.07.01.15.02.22.03v1.68Z"
          />
          <path
            className="cls-34"
            d="m126.89,264.57c.22-.17.45-.33.65-.52,6.32-6.32,12.64-12.64,18.96-18.96.11-.11.21-.24.31-.37.52-.3.93.05,1.33.26,3.41,1.83,7.09,2.79,10.91,2.89,4.09.11,8.01-.88,11.64-2.81,5.76-3.08,10.35-7.44,13.99-12.83.52-.77.93-1.6,1.08-2.52.22-1.34-.13-1.75-1.5-1.76-3-.01-6,0-8.99,0-4.52,0-9.03-.01-13.55,0-.92,0-1.74-.18-2.43-.82-3.45-3.16-6.24-6.79-7.25-11.46-.95-4.4.15-8.48,2.39-12.3,1.35-2.3,3.14-4.22,5.06-6.05.68-.65,1.46-.73,2.32-.73,7.35,0,14.71,0,22.06,0,.5,0,1.24.27,1.44-.22.24-.57-.51-.9-.87-1.28-3.57-3.77-7.19-7.5-11.45-10.52-3.5-2.48-7.11-4.78-11.25-6.04-4.21-1.28-8.35-1.35-12.26,1.02-1.95,1.19-3.56,2.84-5.43,4.13-6.3,4.35-13.17,7.03-20.91,7.04-2.92,0-5.77-.78-8.63-1.35-1.08-.21-1.25-.66-.89-1.9,1.08-3.81,2.39-7.54,3.94-11.19,3.8-8.98,8.94-17.13,15.34-24.48,6.69-7.69,14.48-14.06,23.3-19.19,8.47-4.93,17.52-8.34,27.08-10.38,3.95-.84,7.94-1.37,11.97-1.71,4-.34,8-.33,11.98-.14,6.72.32,13.33,1.45,19.82,3.28,13.06,3.68,24.74,9.94,35.03,18.73,9.09,7.76,16.5,16.9,21.99,27.56,2.98,5.78,5.39,11.77,7.08,18.04.13.79.46,1.53.61,2.32.19.65.27,1.32.45,1.98.16.72.32,1.45.47,2.18.12.68.26,1.35.41,2.02.1.7.25,1.39.33,2.09.04.71.27,1.4.26,2.12.05.58.24,1.15.23,1.74,0,.73.24,1.43.24,2.16.02.67,0,1.34.17,2,.13.77.1,1.55.08,2.33.04.72,0,1.44,0,2.17-.04,1.17.07,2.33,0,3.5.01.72.03,1.43,0,2.15,0,.42,0,.85-.09,1.26-.32.99,0,2.04-.23,3.04-.15.58-.15,1.17-.19,1.76-.14.7-.21,1.41-.31,2.12-.15.56-.14,1.14-.25,1.7-.2.86-.29,1.74-.44,2.61-.11.49-.19.98-.29,1.47-.22.7-.35,1.43-.48,2.15-.23.82-.42,1.66-.63,2.49-3.55,13.55-9.81,25.7-18.89,36.38-7.48,8.8-16.33,15.91-26.46,21.46-10.07,5.52-20.82,8.94-32.18,10.44-4.55.6-9.14.95-13.73.79-13.05-.46-25.53-3.3-37.36-8.93-7.84-3.74-15.02-8.44-21.52-14.21-5.01-4.45-9.5-9.36-13.46-14.75-.43-.59-1.06-1.11-1-1.97Z"
          />
          <path
            className="cls-18"
            d="m290.91,188.07c-1.51-4.79-3.04-9.57-5.24-14.09-13.15-27.02-34.22-44.57-63.55-51.03-31.19-6.88-58.95,1.04-82.57,22.54-12.68,11.55-21.09,25.9-25.73,42.44-.19.69-.25,1.05.67,1.19,3.7.56,7.33,1.55,11.14,1.22,6.49-.56,12.3-2.89,17.64-6.51,1.22-.83,2.45-1.68,3.54-2.67,4.33-3.94,9.28-4.62,14.72-2.99,4.74,1.42,8.81,4.06,12.73,6.98,4.19,3.12,7.71,6.94,11.35,10.64.26.26.58.58.46.92-.17.49-.69.26-1.05.26-7.87.01-15.75.02-23.62,0-.78,0-1.35.21-1.91.74-3.19,3.06-5.76,6.54-6.91,10.87-1.42,5.3.02,10.01,3.21,14.3.1.13.2.25.3.37q3.44,4.39,8.93,4.39c6.59,0,13.19.03,19.78-.03,1.12,0,1.37.48,1.38,1.41.01,1.04-.33,2-.88,2.82-5.42,7.97-12.18,14.15-22.02,16.02-5.16.98-10.07-.09-14.76-2.31-.57-.27-1.14-.56-1.71-.83-3.06-1.41-5.51-3.56-7.61-6.15-1.8-2.22-3.77-4.27-5.82-6.26-4.63-4.49-9.48-8.69-15.35-11.53-2.11-1.02-4.38-1.53-6.63-2.1-2.28-.58-4.53-1.26-6.77-1.96-2.29-.71-4.58-1.44-6.89-2.07-2.19-.59-4.35-1.32-6.52-1.99-3.1-.96-6.19-1.97-9.33-2.81-2.01-.54-3.97-1.25-5.95-1.89-.23-.07-.45-.16-.68-.22q-2.25-.6-2.29-2.83c.25-.65-.03-1.34.17-1.99.02-.48.03-.95.05-1.43.27-.46,0-.98.18-1.45l.07-1.18c.25-.38,0-.83.18-1.22.57-6.42,1.86-12.71,3.49-18.92,1.41-5.39,3.22-10.67,5.36-15.84,1.89-4.57,4.03-9.02,6.4-13.36,2.57-4.69,5.41-9.2,8.59-13.51,2.29-3.11,4.67-6.14,7.21-9.07,2.64-3.04,5.38-5.96,8.28-8.73,2.77-2.65,5.73-5.09,8.7-7.53,8.14-6.7,17.09-12.04,26.59-16.5,8.36-3.92,17.09-6.76,26.1-8.78,5.01-1.13,10.09-1.85,15.19-2.48.39-.16.84.07,1.22-.17.47-.02.95-.05,1.42-.07.49-.15,1.02.07,1.5-.15.7-.03,1.4-.06,2.09-.09.88-.18,1.8.11,2.68-.16,2.92,0,5.83,0,8.75,0,.89.25,1.81-.02,2.7.15.64.02,1.28.05,1.91.07.54.29,1.14-.02,1.69.19.47.02.93.04,1.4.06.39.23.84,0,1.24.18.32.02.63.03.95.05.37.26.82,0,1.21.18,8.56,1.14,16.97,2.93,25.17,5.65,7.3,2.42,14.35,5.44,21.12,9.13,6.39,3.48,12.47,7.43,18.19,11.92,5.58,4.38,10.79,9.17,15.6,14.41,4.81,5.25,9.2,10.81,13.09,16.76,7.2,11.02,12.7,22.82,16.23,35.52.95,3.41,1.74,6.84,2.54,10.28.07.31.04.63.06.95-.07.55-.53.52-.9.58-.39.07-.8.04-1.19.04-11.73,0-23.46,0-35.19,0-.71,0-1.45.11-2.07-.38Z"
          />
          <path
            className="cls-6"
            d="m126.89,264.57c13.9,19.61,32.55,32.12,56.01,37.42,7.2,1.63,14.52,2.28,21.89,2.04,20.76-.69,39.29-7.53,55.42-20.63,15.35-12.46,25.61-28.3,30.78-47.41.06-.23.16-.45.24-.68.45-.43,1.03-.38,1.58-.38,12.28-.01,24.55,0,36.83,0,.36,0,.72-.02,1.05.17-1.17,6.53-2.77,12.94-4.92,19.22-4.64,13.55-11.3,26-20.04,37.35-3.48,4.51-7.22,8.8-11.25,12.81-6.52,6.47-13.63,12.24-21.37,17.21-7.62,4.9-15.65,8.97-24.11,12.22-7.82,3.01-15.87,5.17-24.12,6.61-3.38.59-6.78,1.07-10.21,1.36-.47.16-.98-.1-1.44.17-.48.02-.95.03-1.43.05-.64.21-1.33-.08-1.97.18l-2.82.06c-2.71.13-5.42.1-8.13.01-1.02-.03-2.04-.05-3.07-.08-.64-.25-1.32,0-1.97-.16-.55-.03-1.1-.05-1.65-.08-.47-.25-1,.02-1.47-.18-.39-.02-.78-.04-1.16-.06-.39-.24-.84,0-1.23-.18-6.81-.59-13.48-2-20.06-3.77-5.48-1.47-10.84-3.35-16.08-5.6-4.04-1.74-8.01-3.6-11.86-5.71-5.46-2.99-10.69-6.36-15.65-10.13-2.9-2.2-5.72-4.51-8.42-6.97-1.99-1.81-4.06-3.56-5.9-5.51-3.63-3.84-7.16-7.76-10.41-11.95-4.12-5.29-7.71-10.91-11.06-16.69-2.53-4.37-4.57-8.99-6.49-13.67-1.49-3.63-2.76-7.34-3.95-11.07-1.46-4.6-2.64-9.28-3.51-14.02-.67-3.63-1.22-7.31-1.52-11.01-.09-1.14-.4-1.56,1.14-1.07,6.16,1.97,12.38,3.76,18.58,5.62,6.38,1.92,12.75,3.85,19.13,5.77.89.27,1.45.62,1.77,1.71,2.78,9.68,7.03,18.67,12.75,26.97.02.03.07.03.11.05Z"
          />
          <path
            className="cls-6"
            d="m52.8,287.83c-1.24-2.7-.4-5.28.36-7.9,1.4-4.82,2.73-9.66,4.11-14.59-.88-.03-1.58.38-2.31.61-3.57,1.14-7.13,2.32-10.71,3.42-.88.27-1.38.78-1.78,1.58-2.87,5.7-5.76,11.39-8.67,17.07-1.63,3.19-5.27,4.17-8.1,2.22-2.26-1.57-2.93-4.49-1.6-7.15,1.16-2.32,2.36-4.62,3.54-6.92.23-.45.46-.91.81-1.61-2.83.92-5.43,1.75-8.03,2.59-4.24,1.38-8.48,2.8-12.73,4.15-3.11.99-6.04-.49-7.01-3.46-.96-2.92.58-5.81,3.7-6.88,1.39-.48,2.8-.92,4.2-1.37,5.19-1.69,10.39-3.37,15.58-5.06.23-.07.45-.17.87-.34-2.38-1.21-4.63-2.37-6.89-3.51-1.45-.74-2.95-1.41-3.99-2.75-.43-.68-.62-1.45-.78-2.23-.08-.55-.08-1.1,0-1.65.61-4.29,5.14-5.46,8.16-3.87,5.65,2.99,11.38,5.84,17.07,8.78.68.35,1.27.45,2.03.19,4-1.34,8.02-2.62,12.03-3.94.27-.09.72-.03.79-.41.06-.37-.34-.44-.58-.63-3.26-2.6-6.5-5.24-9.77-7.83-1.22-.97-2.5-1.86-3.69-2.88-1.2-1.03-1.98-2.27-2.26-3.83-.12-.87-.09-1.74-.02-2.61.56-3.15,2.54-4.81,5.59-5.35.63-.1,1.26-.09,1.89,0,2.13.38,3.66,1.8,5.27,3.07,5.58,4.39,11.15,8.79,16.73,13.19,2.37,1.87,4.72,3.74,7.09,5.61.4.32.46.65.32,1.14-2.15,7.62-4.28,15.25-6.42,22.88-.79,2.8-1.59,5.61-2.37,8.41-.82,2.96-2.69,4.77-5.75,5.29-.47.12-.95.11-1.42,0-2.37-.18-4.09-1.39-5.28-3.41Z"
          />
          <path
            className="cls-6"
            d="m299.38,326.94c.95-.02,1.9-.04,2.84-.06,1.04-.22,2.11.11,3.14-.19.95-.02,1.91-.04,2.86-.06,1.03-.22,2.1.12,3.12-.18,2.18,0,4.19.43,5.47,2.42,2.03,3.16.44,7.25-3.34,8.18-.56.19-1.17-.07-1.73.17l-3.07.08c-.97.19-1.96-.1-2.93.16-1.02.03-2.05.06-3.07.08-.96.17-1.95-.1-2.91.16-.53.04-1.27-.31-1.53.19-.21.39.46.84.75,1.24,1.82,2.55,3.7,5.04,5.52,7.58.39.54.81.75,1.45.85,3.82.59,7.63,1.23,11.44,1.84,1.21.19,2.42.39,3.63.53,2.54.29,4.09,2.14,3.98,4.74-.09,2.02-2.22,4.09-4.45,3.93-2.38-.17-4.69-.73-7.05-.99q-.65-.19-.75.28c2.13,3.27,4.57,6.32,6.79,9.52,1.32,1.9,2.97,3.59,3.83,5.8.11.63.12,1.27-.01,1.9-1.15,2.71-2.47,3.55-5.21,3.31-1.43-.12-2.28-1.12-3.04-2.14-3.04-4.15-6.03-8.34-9.05-12.51-.19-.26-.39-.72-.78-.59-.35.11-.36.59-.41.92-.34,2.06-.65,4.13-.98,6.2-.37,2.35-2.47,3.82-5.07,3.56-1.76-.17-3.74-2.2-3.55-4.28.23-2.49.75-4.93,1.07-7.4.24-1.89.55-3.78.85-5.66.17-1.07.33-2.16.55-3.21.15-.72-.06-1.04-.42-1.53-1.96-2.65-3.88-5.33-5.8-8.01-.16-.23-.29-.53-.57-.53-.35,0-.35.39-.44.62-1.47,3.95-2.93,7.91-4.36,11.88-1.14,3.16-3.04,4.41-6.28,4.25-1.65-.08-3.98-2.27-4.28-4.04-.28-1.69.23-3.13.78-4.61.91-2.45,1.84-4.91,2.75-7.36,1.27-3.42,2.54-6.85,3.81-10.27.76-2.04,1.51-4.08,2.27-6.12.73-.18,1.49.09,2.21-.16,1.02-.03,2.04-.05,3.07-.08.96-.19,1.95.1,2.91-.17,1.03-.03,2.06-.05,3.09-.08.96-.17,1.95.1,2.91-.16Z"
          />
          <path
            className="cls-6"
            d="m108.18,327.11c.95.02,1.91.04,2.86.06,1.03.29,2.1-.04,3.14.19.95.02,1.9.04,2.84.06.77.41,1.75-.33,2.44.47,1.08,3.59,2.53,7.05,3.82,10.57,1.84,5.04,3.73,10.07,5.59,15.1.09.79.11,1.58,0,2.38-1.25,2.99-2.81,4.13-5.6,4.09-2.36-.04-4.16-1.56-4.99-4.06-1.35-4.07-2.93-8.06-4.42-12.08-.47-1.26-.76-.46-1.05-.07-1.62,2.2-3.01,4.6-4.84,6.59-1.69,1.84-1.23,3.71-.91,5.7.69,4.25,1.44,8.49,2.07,12.75.28,1.88-.4,3.49-2.13,4.43-1.72.94-3.46.99-5.05-.35-1.11-.94-1.44-2.25-1.64-3.62-.32-2.13-.67-4.27-1.06-6.77-1.41,1.93-2.61,3.57-3.8,5.21-2.14,2.95-4.28,5.9-6.42,8.86-1.96,2.71-6.27,2.63-7.64-.78-.54-1.34-.58-2.8.32-4.05,3.16-4.38,6.37-8.73,9.55-13.1.2-.28.34-.61.58-1.03-1.76-.15-3.39.34-5.03.55-1.1.14-2.17.36-3.29.4-2.08.08-3.85-1.83-4.04-3.67-.28-2.74,1.18-4.57,3.42-4.95,5.23-.87,10.48-1.64,15.71-2.44.48-.07.82-.27,1.14-.7,2.05-2.83,4.16-5.62,6.23-8.44.13-.18.15-.43.24-.7h-1.36c-1.03-.31-2.09.04-3.12-.18-.96-.02-1.92-.04-2.87-.06-1.03-.3-2.09.04-3.12-.19l-2.86-.05c-.54-.27-1.14,0-1.69-.17-2.7-.33-4.2-2.48-4.39-4.63-.09-.39-.08-.78,0-1.17.13-2.8,2.65-4.87,5.43-4.78.35.01.71-.01,1.06-.02.96.27,1.95-.02,2.91.17,1.02.03,2.04.05,3.07.08.96.26,1.96-.03,2.93.16.96.02,1.92.04,2.88.06,1.03.31,2.09-.04,3.12.18Z"
          />
          <path
            className="cls-18"
            d="m66.47,173.96c-3.15-.73-6.12-2-9.18-2.97-4.98-1.58-9.96-3.15-14.93-4.76-4.75-1.54-9.48-3.15-14.22-4.7-4.81-1.57-9.62-3.1-14.43-4.65-3.21-1.03-6.42-2.07-9.63-3.12-2.09-.69-3.23-2.2-3.61-4.32-.1-.64-.12-1.27.01-1.91.45-2.46,1.95-3.87,4.36-4.37.63-.12,1.27-.09,1.9-.02,5.31,1.72,10.62,3.42,15.93,5.15,9.53,3.1,19.06,6.21,28.59,9.31,5.9,1.92,11.81,3.84,17.72,5.75,2.57.83,4.27,2.87,4.13,5.28-.14,2.43-1.35,4.49-4.26,5.32-.79.09-1.59.1-2.38,0Z"
          />
          <path
            className="cls-18"
            d="m196.88,4.84c.51-2.38,1.69-3.84,4.37-4.38.63-.1,1.27-.09,1.9,0,3.22.99,4.53,2.75,4.53,6.07,0,21.33-.01,42.65,0,63.98,0,5.06-5.16,6.98-8.24,5.08-1.46-.89-2.34-2.15-2.59-3.85-.09-.35-.05-.72-.05-1.07,0-21.58,0-43.17,0-64.75,0-.36-.05-.72.07-1.07Z"
          />
          <path
            className="cls-18"
            d="m119.5,93.8c-.94,2.13-2.44,3.28-4.89,3.15-1.5-.08-2.42-1.01-3.15-2.01-5.5-7.48-10.93-15.02-16.38-22.54-4.64-6.4-9.3-12.8-13.93-19.21-1.75-2.42-.72-6.28,2.6-6.93.63-.08,1.26-.08,1.9,0,2.07.56,3.01,2.33,4.13,3.88,7.3,10.05,14.56,20.12,21.85,30.17,2.28,3.14,4.6,6.24,6.88,9.38.39.54.67,1.15,1,1.73.13.8.13,1.59,0,2.39Z"
          />
          <path
            className="cls-18"
            d="m289.43,96.93c-1.85,0-3.2-.56-3.99-2.01-.85-1.56-.97-3.18.1-4.7,2.88-4.09,5.82-8.13,8.82-12.13,2.45-3.27,4.77-6.64,7.17-9.95,3.81-5.25,7.65-10.49,11.48-15.73,1.03-1.41,2.07-2.81,3.11-4.21,1.6-2.16,4.3-2.66,6.31-1.16,1.97,1.47,2.31,4.14.75,6.28-7.5,10.3-15.02,20.59-22.52,30.89-2.63,3.61-5.21,7.25-7.84,10.86-.89,1.22-2.08,1.92-3.39,1.86Z"
          />
          <path
            className="cls-28"
            d="m290.91,188.07c12.66,0,25.32,0,37.99-.02.46,0,.97.18,1.37-.22.31.85.5,1.72.48,2.63-.45.44-1.03.38-1.58.38-12.03,0-24.05,0-36.08,0-.56,0-1.12-.02-1.6-.39-.19-.8-.38-1.59-.57-2.39Z"
          />
          <path
            className="cls-13"
            d="m294.09,208.93c-.04-.79-.07-1.58-.11-2.38.44-.47,1.02-.4,1.57-.41,11.84-.01,23.69-.01,35.53,0,.4,0,.8,0,1.18.14.15.07.28.16.4.26-.01.79-.02,1.59-.03,2.38-.45.44-1.03.39-1.58.39-11.79,0-23.58,0-35.37,0-.55,0-1.13.05-1.59-.39Z"
          />
          <path
            className="cls-15"
            d="m291.86,232.84c.04-.75.18-1.48.46-2.17,3.67.34,7.35.15,11.02.16,8.59.03,17.19,0,25.78.02.7,0,1.45-.17,2.06.38.19.75-.19,1.44-.24,2.16-.45.44-1.03.38-1.58.39-11.82,0-23.65.02-35.47-.02-.75,0-1.76.28-2.03-.92Z"
          />
          <path
            className="cls-19"
            d="m291.48,190.46c13.09,0,26.17,0,39.26,0,.4.43.2.97.24,1.46.31.64-.07.88-.6,1.01-.43.1-.87.08-1.31.08-11.69,0-23.38,0-35.07,0-.73,0-1.55.18-2.06-.62-.15-.64-.31-1.28-.46-1.93Z"
          />
          <path
            className="cls-2"
            d="m292.61,229.31c.02-.93.19-1.83.45-2.72.87.15,1.75.18,2.63.18,11.19,0,22.38,0,33.57,0,.88,0,1.75-.14,2.63-.09-.25.86.01,1.79-.42,2.62-.46.41-1.03.39-1.59.39-11.9,0-23.8,0-35.69,0-.55,0-1.13.06-1.58-.39Z"
          />
          <path
            className="cls-17"
            d="m293.12,198.61c-.11-.71-.23-1.42-.34-2.14.44-.47,1.02-.41,1.57-.41,11.92-.01,23.83-.01,35.75,0,.55,0,1.13-.05,1.58.39-.05.73.41,1.41.24,2.16-.45.44-1.03.39-1.58.39-11.88,0-23.75,0-35.63,0-.55,0-1.13.04-1.58-.39Z"
          />
          <path
            className="cls-29"
            d="m331.88,226.69c-.26.44-.67.47-1.14.47-12.19,0-24.38,0-36.57-.01-.46,0-1.01.15-1.12-.56.04-.54-.03-1.1.23-1.61.51-.4,1.12-.37,1.72-.37,11.77,0,23.54,0,35.31,0,.52,0,1.04-.03,1.52.24.4.4.2.88.17,1.34-.04.17-.08.34-.12.51Z"
          />
          <path
            className="cls-11"
            d="m332.02,225.03c-10.32-.01-20.64-.02-30.96-.03-2.59,0-5.18-.01-7.77-.02.04-.72.02-1.45.28-2.14.46-.41,1.03-.39,1.59-.39,11.84,0,23.67,0,35.51,0,.48,0,.96,0,1.4.23.37.32.23.72.17,1.1-.02.4-.04.8-.06,1.19-.05.02-.11.03-.16.05Z"
          />
          <path
            className="cls-31"
            d="m293.83,204.61c-.12-.71-.28-1.43-.22-2.16.45-.44,1.03-.38,1.58-.38,11.88,0,23.77,0,35.65,0,.4,0,.8,0,1.18.14.15.07.28.16.4.27.02.55.04,1.11.06,1.66.08.25.06.47-.18.63-.56.29-1.17.23-1.76.23-11.59,0-23.17,0-34.76,0-.67,0-1.37.12-1.95-.39Z"
          />
          <path
            className="cls-3"
            d="m293.74,221.14c.09-1.06-.03-2.14.28-3.19.68.73,1.58.66,2.45.66,11.25,0,22.5,0,33.76,0,.71,0,1.44-.11,2.11.25.38.49.17,1.03.16,1.56-.04.25-.07.49-.11.74-.45.44-1.03.39-1.58.39-11.83.01-23.66.01-35.49,0-.55,0-1.13.06-1.57-.4Z"
          />
          <path
            className="cls-10"
            d="m294.07,216.84c0-.72.02-1.44.03-2.16.45-.44,1.03-.38,1.58-.39,11.79,0,23.58,0,35.36,0,.55,0,1.13-.06,1.58.39,0,.64-.02,1.29-.03,1.93-.42.75-1.16.61-1.82.61-4.64.02-9.27.01-13.91.01-6.95,0-13.91,0-20.86,0-.67,0-1.37.12-1.95-.39Z"
          />
          <path
            className="cls-5"
            d="m294.07,216.84c12.34,0,24.68,0,37.02,0,.51,0,1.05.1,1.51-.23.02.54.03,1.08.05,1.62-.18.23-.04.53-.19.77-12.36,0-24.72,0-37.08,0-.77,0-1.48.04-1.37-1.05-.1-.38-.06-.75.06-1.11Z"
          />
          <path
            className="cls-8"
            d="m291.86,232.84c.47.67,1.19.54,1.85.54,12.41,0,24.82,0,37.23,0-.09.56-.18,1.13-.27,1.69-.47.33-1,.22-1.51.22-12.65,0-25.3,0-37.95,0,.16-.83.3-1.68.64-2.46Z"
          />
          <path
            className="cls-21"
            d="m331.67,196.45c-12.96,0-25.93.02-38.89.02-.12-.65-.25-1.29-.37-1.94.61-.53,1.36-.38,2.06-.38,11.42-.01,22.83,0,34.25,0,.92,0,1.86.09,2.5-.79.35,1,.3,2.06.45,3.1Z"
          />
          <path
            className="cls-27"
            d="m331.22,193.36c.15,1.13-.54,1.19-1.41,1.19-12.47-.01-24.94,0-37.41,0-.15-.72-.31-1.43-.46-2.15.43.3.91.23,1.39.23,12.12,0,24.23,0,36.35-.01.5,0,1.31.37,1.3-.69.38.43.2.95.24,1.44Z"
          />
          <path
            className="cls-9"
            d="m292.61,229.31c12.95,0,25.91,0,38.86,0-.02.65.12,1.32-.28,1.92-12.34,0-24.68,0-37.01,0-.67,0-1.38.12-1.85-.56.03-.47,0-.94.28-1.36Z"
          />
          <path
            className="cls-14"
            d="m332.26,202.43c-12.88,0-25.76.02-38.64.03-.07-.56-.15-1.12-.22-1.68.54-.72,1.34-.62,2.09-.62,5.35-.01,10.7,0,16.05,0,6.07,0,12.14-.01,18.21.01.94,0,1.73-.13,2.2-1.05.33.6.13,1.29.31,1.91.08.47.08.93,0,1.4Z"
          />
          <path
            className="cls-32"
            d="m332.63,214.68h-38.53c0-1.2,0-2.4,0-3.6.17-.03.3.04.38.19.27,1.15,1.16,1.11,2.06,1.11,11.31,0,22.61,0,33.92,0,.71,0,1.44-.11,2.12.25.34.41.19.87.13,1.32-.03.24-.06.49-.08.73Z"
          />
          <path
            className="cls-16"
            d="m331.94,199.11c.21,1.17-.3,1.45-1.44,1.45-11.74-.04-23.49-.02-35.23-.03-.64,0-1.27.02-1.88.24-.09-.72-.18-1.44-.27-2.16,12.93,0,25.86,0,38.79,0l.03.5Z"
          />
          <path
            className="cls-26"
            d="m294.3,211.09h-.1s-.1,0-.1,0c0-.72,0-1.44-.01-2.16,12.85,0,25.69,0,38.54,0,.03.65.07,1.3.1,1.95-.06.05-.12.1-.18.15-.56.27-1.17.21-1.77.21-11.73,0-23.46,0-35.18,0-.44,0-.88.01-1.3-.15Z"
          />
          <path
            className="cls-4"
            d="m293.74,221.14c12.88,0,25.76.01,38.65.02,0,.38.02.76.02,1.13-.1.17-.07.39-.2.55-12.88,0-25.76,0-38.64,0,.01-.57-.07-1.15.17-1.7Z"
          />
          <path
            className="cls-34"
            d="m196.88,4.84c-.02,1.36-.06,2.71-.06,4.07,0,19.3,0,38.61,0,57.91,0,1.64.03,3.27.04,4.91-.3-.39-.17-.85-.17-1.27,0-21.45,0-42.9,0-64.35,0-.42-.14-.88.19-1.27Z"
          />
          <path
            className="cls-34"
            d="m196.7,397.26c.26.31.12.69.12,1.03.02,7.15.03,14.29.04,21.44-.24-.27-.18-.6-.18-.91,0-7.18,0-14.37.01-21.55Z"
          />
          <path
            className="cls-34"
            d="m196.69,366.81c.23.23.14.52.14.79,0,4.29,0,8.57,0,12.86,0,.31.08.64-.14.92,0-4.86,0-9.71,0-14.57Z"
          />
          <path
            className="cls-34"
            d="m198.86,342.33c2.71,0,5.42,0,8.13-.01-.83.42-1.72.2-2.57.18-1.85-.04-3.72.25-5.56-.16Z"
          />
          <path
            className="cls-34"
            d="m108.18,327.11c-1.04,0-2.09.06-3.12-.18,1.04.09,2.1-.23,3.12.18Z"
          />
          <path
            className="cls-34"
            d="m101.73,337.53c1.04,0,2.09-.06,3.12.18-1.04-.09-2.1.23-3.12-.18Z"
          />
          <path
            className="cls-34"
            d="m114.18,327.36c-1.05.01-2.1.05-3.14-.19,1.04.08,2.11-.24,3.14.19Z"
          />
          <path
            className="cls-34"
            d="m95.73,337.28c1.05,0,2.09-.06,3.12.19-1.04-.09-2.1.24-3.12-.19Z"
          />
          <path
            className="cls-34"
            d="m332.71,213.95c-.02-.4-.04-.79-.06-1.19-.44-.64-.43-1.28-.02-1.93,0,0,.09.04.09.04.29,1.03.31,2.06-.01,3.08Z"
          />
          <path
            className="cls-34"
            d="m311.34,326.45c-1.03.25-2.08.19-3.12.18,1.02-.41,2.08-.09,3.12-.18Z"
          />
          <path
            className="cls-34"
            d="m305.36,326.69c-1.04.24-2.09.2-3.14.19,1.02-.43,2.09-.1,3.14-.19Z"
          />
          <path
            className="cls-34"
            d="m299.77,337.7c.96-.21,1.93-.21,2.91-.16-.95.36-1.94.1-2.91.16Z"
          />
          <path
            className="cls-34"
            d="m102.18,326.87c-.98.04-1.96.05-2.93-.16.98.05,1.97-.21,2.93.16Z"
          />
          <path
            className="cls-34"
            d="m96.19,326.63c-.97.04-1.95.05-2.91-.17.97.06,1.96-.21,2.91.17Z"
          />
          <path
            className="cls-34"
            d="m299.38,326.94c-.96.21-1.93.21-2.91.16.95-.36,1.94-.1,2.91-.16Z"
          />
          <path
            className="cls-34"
            d="m293.38,327.18c-.96.23-1.93.2-2.91.17.95-.38,1.94-.11,2.91-.17Z"
          />
          <path
            className="cls-34"
            d="m305.75,337.46c.97-.21,1.95-.2,2.93-.16-.96.37-1.95.11-2.93.16Z"
          />
          <path
            className="cls-34"
            d="m198.41,82.31c-.88.18-1.78.2-2.68.16.87-.37,1.78-.1,2.68-.16Z"
          />
          <path
            className="cls-34"
            d="m37.14,237c0,.87.01,1.74.02,2.61-.32-.87-.29-1.74-.02-2.61Z"
          />
          <path
            className="cls-34"
            d="m209.87,82.47c-.91.06-1.81,0-2.7-.15.9.05,1.82-.22,2.7.15Z"
          />
          <path
            className="cls-34"
            d="m119.46,327.89c-.73-.6-1.66-.12-2.44-.47.8.23,1.8-.56,2.44.47Z"
          />
          <path
            className="cls-34"
            d="m223.83,401.26c0-.87,0-1.75,0-2.62.33.87.33,1.75,0,2.62Z"
          />
          <path
            className="cls-34"
            d="m128.86,355.93c0-.79,0-1.58,0-2.38.3.79.31,1.58,0,2.38Z"
          />
          <path
            className="cls-34"
            d="m66.47,173.96c.79,0,1.59,0,2.38,0-.79.3-1.59.31-2.38,0Z"
          />
          <path
            className="cls-34"
            d="m335.55,173.95c.79,0,1.59.02,2.38.03-.8.27-1.59.32-2.38-.03Z"
          />
          <path
            className="cls-34"
            d="m119.5,93.8v-2.39c.33.8.33,1.59,0,2.39Z"
          />
          <path
            className="cls-34"
            d="m332.41,204.61c.02-.16.04-.31.06-.47.38.78.11,1.6.18,2.4-.05-.02-.1-.04-.16-.04-.59-.6-.51-1.24-.09-1.89Z"
          />
          <path
            className="cls-34"
            d="m361.92,231.67c-.71,0-1.43,0-2.14,0,.71-.3,1.43-.31,2.14,0Z"
          />
          <path
            className="cls-34"
            d="m233.21,372.24c0-.71,0-1.42,0-2.13.28.71.28,1.42,0,2.13Z"
          />
          <path
            className="cls-34"
            d="m332.47,219c.06-.26.12-.51.19-.77-.05.73.2,1.48-.16,2.19,0-.47-.02-.95-.03-1.42Z"
          />
          <path
            className="cls-34"
            d="m287.41,327.42c-.73.2-1.47.16-2.21.16.71-.37,1.47-.12,2.21-.16Z"
          />
          <path
            className="cls-34"
            d="m209.81,342.25c.64-.22,1.31-.18,1.97-.18-.63.39-1.31.13-1.97.18Z"
          />
          <path
            className="cls-34"
            d="m6.73,143.15c-.63,0-1.27.01-1.9.02.63-.31,1.26-.29,1.9-.02Z"
          />
          <path
            className="cls-34"
            d="m.47,147.54c0,.64,0,1.27-.01,1.91-.3-.64-.31-1.27.01-1.91Z"
          />
          <path
            className="cls-34"
            d="m193.82,342.1c.66-.04,1.32-.05,1.97.16-.66-.04-1.33.2-1.97-.16Z"
          />
          <path
            className="cls-34"
            d="m44.62,231.65c-.63,0-1.26,0-1.89,0,.63-.29,1.26-.28,1.89,0Z"
          />
          <path
            className="cls-34"
            d="m73.13,202.94c.02.67.01,1.34-.17,1.99.04-.66-.22-1.35.17-1.99Z"
          />
          <path
            className="cls-34"
            d="m85.64,46.25c-.63,0-1.26,0-1.9,0,.63-.28,1.26-.28,1.9,0Z"
          />
          <path
            className="cls-34"
            d="m323.35,375.12c0-.63,0-1.27.01-1.9.3.64.32,1.27-.01,1.9Z"
          />
          <path
            className="cls-34"
            d="m203.15.45c-.63,0-1.27,0-1.9,0,.63-.3,1.26-.29,1.9,0Z"
          />
          <path
            className="cls-34"
            d="m213.47,82.73c-.57,0-1.14.02-1.69-.19.56.06,1.16-.19,1.69.19Z"
          />
          <path
            className="cls-34"
            d="m13.39,254.03c0,.55,0,1.1,0,1.65-.27-.55-.27-1.1,0-1.65Z"
          />
          <path
            className="cls-34"
            d="m311.74,337.22c.58-.06,1.15-.11,1.73-.17-.55.37-1.15.13-1.73.17Z"
          />
          <path
            className="cls-34"
            d="m91.18,337.06c.56.06,1.15-.07,1.69.17-.56-.05-1.16.18-1.69-.17Z"
          />
          <path
            className="cls-34"
            d="m217.8,405.39h1.42c-.47.3-.95.3-1.42,0Z"
          />
          <path
            className="cls-34"
            d="m193.64,82.56c-.49.17-.99.2-1.5.15.47-.33,1-.13,1.5-.15Z"
          />
          <path
            className="cls-34"
            d="m190.7,341.84c.5-.01,1-.05,1.47.18-.49-.04-1.02.18-1.47-.18Z"
          />
          <path
            className="cls-34"
            d="m213.22,342.03c.46-.22.95-.2,1.44-.17-.45.33-.96.12-1.44.17Z"
          />
          <path
            className="cls-34"
            d="m58.08,291.24c.47,0,.95,0,1.42,0-.47.3-.95.3-1.42,0Z"
          />
          <path
            className="cls-34"
            d="m352.38,285.42c0-.47.01-.94.02-1.42.27.48.29.95-.02,1.42Z"
          />
          <path
            className="cls-34"
            d="m331.42,167.92v1.42c-.29-.47-.29-.95,0-1.42Z"
          />
          <path
            className="cls-34"
            d="m312.74,357.9c-.18-.1-.38-.36-.24-.43.31-.16.69-.06.99.15-.28.02-.59-.03-.75.28Z"
          />
          <path
            className="cls-34"
            d="m332.21,222.84c.07-.18.13-.36.2-.55-.03.5.18,1.03-.17,1.49,0-.32-.02-.63-.03-.95Z"
          />
          <path
            className="cls-34"
            d="m332.26,202.43c0-.47,0-.93,0-1.4.33.45.12.97.16,1.45-.05-.03-.11-.05-.16-.05Z"
          />
          <path
            className="cls-34"
            d="m73.36,200.06c.03.49.02.98-.18,1.45.05-.48-.16-1,.18-1.45Z"
          />
          <path
            className="cls-34"
            d="m190.72,82.78c-.39.19-.8.2-1.22.17.37-.32.81-.14,1.22-.17Z"
          />
          <path
            className="cls-34"
            d="m216.11,82.97c-.43.02-.85.03-1.24-.18.42.02.87-.16,1.24.18Z"
          />
          <path
            className="cls-34"
            d="m218.26,83.2c-.42.02-.83.02-1.21-.18.41.04.85-.14,1.21.18Z"
          />
          <path
            className="cls-34"
            d="m188.3,341.6c.42-.03.84-.02,1.23.18-.42-.03-.86.16-1.23-.18Z"
          />
          <path
            className="cls-34"
            d="m86.78,331.26v1.17c-.27-.39-.26-.78,0-1.17Z"
          />
          <path
            className="cls-34"
            d="m347.52,266.05c-.17-.22-.37-.49-.1-.71.18-.15.44,0,.62.18-.34.02-.5.2-.52.53Z"
          />
          <path
            className="cls-34"
            d="m332.02,225.03c.06,0,.11-.02.16-.05-.04.4.14.84-.18,1.2l.02-1.15Z"
          />
          <path
            className="cls-34"
            d="m73.61,197.66c.03.42.02.83-.18,1.22.03-.41-.15-.85.18-1.22Z"
          />
          <path
            className="cls-34"
            d="m185.43,405.41c.39,0,.78,0,1.17,0-.39.27-.78.27-1.17,0Z"
          />
          <path
            className="cls-34"
            d="m345.15,291.25c.39,0,.78,0,1.17,0-.39.26-.78.27-1.17,0Z"
          />
          <path
            className="cls-7"
            d="m194.77,212.34c0-7.75.02-15.49-.03-23.24,0-1,.35-1.17,1.23-1.15,2.16.05,4.31.08,6.47,0,1.07-.04,1.33.28,1.32,1.33-.04,11.9-.02,23.8-.02,35.7,0,3.59-.02,7.19.02,10.78,0,.79-.22,1.02-1,1.01-2.32-.05-4.63-.06-6.95,0-.85.02-1.06-.23-1.05-1.06.03-7.79.02-15.57.02-23.36Z"
          />
          <path
            className="cls-7"
            d="m280.83,223.98c0,3.84-.03,7.67.02,11.51.01.96-.18,1.32-1.22,1.28-2.19-.09-4.4-.08-6.59,0-.98.03-1.27-.21-1.27-1.23.05-7.27.03-14.55.02-21.82,0-.44.01-.88-.03-1.32-.19-2.12-1.61-3.22-3.71-2.88-.35.06-.72.1-1.06.2-1.82.51-3.17-.15-4.31-1.56-2.18-2.7-2.2-2.69,1-3.84,2.41-.87,4.83-1.59,7.43-1.68,4.86-.18,8.88,3.1,9.51,7.94.44,3.38.11,6.78.2,10.18.03,1.08,0,2.16,0,3.24Z"
          />
          <path
            className="cls-7"
            d="m260.34,223.49c0,4.03-.03,8.07.02,12.1.01.97-.29,1.2-1.21,1.17-2.19-.06-4.39-.07-6.59,0-.98.03-1.27-.22-1.26-1.23.05-7.19.02-14.38.03-21.57,0-.84-.05-1.68-.26-2.49-.37-1.47-1.44-2.17-2.95-2-.04,0-.08.01-.12.02-3.59.89-4.4-.02-6.48-3.49-.21-.35-.43-.69.19-.93,3.25-1.23,6.47-2.55,10.04-2.46,4.66.11,8.13,3.62,8.5,8.54.03.44.08.88.08,1.31,0,3.67,0,7.35,0,11.02Z"
          />
          <path
            className="cls-7"
            d="m230.74,221.64c-.15-4.04.28-9-.24-13.95-.13-1.23-.35-2.45-.61-3.66-.1-.5-.01-.63.48-.63,2.16.01,4.32.02,6.48,0,.48,0,.69.31.95.62,1.46,1.74,1.99,3.82,2,6.02.03,8.55,0,17.11.03,25.66,0,.85-.24,1.08-1.07,1.06-2.32-.06-4.64-.07-6.95,0-.96.03-1.09-.31-1.09-1.15.04-4.36.02-8.71.02-13.98Z"
          />
          <path
            className="cls-7"
            d="m212.48,219.95c0-5.11.03-10.22-.03-15.34-.01-1.02.29-1.26,1.26-1.23,2.27.07,4.55.05,6.83,0,.72-.01.96.19.95.93-.02,10.5-.02,21.01,0,31.51,0,.76-.26.93-.97.92-2.32-.04-4.63-.06-6.95,0-.89.02-1.14-.21-1.13-1.12.05-5.23.02-10.46.02-15.7Z"
          />
          <path
            className="cls-7"
            d="m211.72,193.65c.09-3.03,2.41-5.35,5.33-5.31,3.04.04,5.38,2.54,5.29,5.63-.1,3.07-2.51,5.23-5.72,5.12-2.78-.09-4.98-2.53-4.9-5.44Z"
          />
          <path
            className="cls-12"
            d="m332.41,204.61c.03.63.06,1.26.09,1.89-11.05,0-22.1.02-33.14.03-1.79,0-3.59.01-5.38.02-.21-.63-.15-1.29-.15-1.94h38.58Z"
          />
          <path
            className="cls-24"
            d="m110.54,210.9v3.01s-.08,0-.11,0v-3.01s.08,0,.11,0Z"
          />
          <path
            className="cls-23"
            d="m110.68,205.64c.21.56.16.94,0,1.33v-1.33Z"
          />
          <path
            className="cls-22"
            d="m110.92,202.8c.19.36.19.61.05.87-.23-.23-.14-.47-.05-.87Z"
          />
          <path
            className="cls-1"
            d="m246.98,299.06c4.19.02,6.62,1.07,8.71,2.86,4.34,3.71,6.79,8.47,7.11,14.15.26,4.59-1.55,8.26-5.75,10.49-4.22,2.23-8.4,2.07-12.13-.89-5.07-4.02-7.74-9.42-7.64-15.93.09-5.94,5.22-10.7,9.71-10.67Z"
          />
          <path
            className="cls-1"
            d="m159.22,300.8c4.12.09,7.39,1.65,10.21,4.28.39.36.41.64,0,.96-.03.02-.06.06-.08.08-.69.67-1.27,1.63-2.09,1.93-.94.34-1.53-.87-2.31-1.34-3.83-2.32-7.41-2.03-10.64,1.22-2.84,2.86-4.48,6.38-4.92,10.41-.09.83-.05,1.67.22,2.49.81,2.52,3.33,3.6,5.65,2.35,2.22-1.19,3.34-3.16,3.53-5.62.12-1.46-.57-2.5-1.98-2.91-1.83-.53-2.51-1.8-2.72-3.52-.05-.45-.05-.77.55-.79,4.98-.16,9.06,2.83,9.75,7.07.72,4.42-2.32,9.07-6.92,10.44-6.13,1.83-13.1-2.89-13.53-9.28-.36-5.38,1.66-9.93,5.46-13.66,2.76-2.72,6.17-4.05,9.85-4.11Z"
          />
          <path
            className="cls-1"
            d="m184.94,315.29c-3.31,3.48-6.43,6.76-9.63,10.12.53.12.94.23,1.36.31,2.23.43,3.65,2.09,3.7,4.34.02.99-.69.46-.99.4-2.43-.46-4.85-.97-7.27-1.48-1.01-.21-2.47-.15-2.9-.78-.55-.8.31-2.09.41-3.18.05-.58.49-.91.84-1.27,3.95-4.13,8.05-8.12,11.8-12.42,1.86-2.13,3.56-2.81,6.31-1.98,2.87.87,2.97.63,2.37,3.61-.92,4.61-1.87,9.23-2.85,13.83-.2.92-.04,1.31.96,1.49,2.03.37,2.02.43,1.6,2.43,0,.04-.02.08-.03.12-.41,1.86-.42,1.9-2.3,1.44-1-.24-1.45-.03-1.55,1.05-.1,1.03-.44,2.03-.59,3.05-.12.87-.36,1.28-1.37.96-1.06-.33-2.18-.48-3.28-.67-.65-.11-.89-.27-.72-1.07,1.41-6.67,2.74-13.35,4.16-20.31Z"
          />
          <path
            className="cls-1"
            d="m219.22,327.55c4.19-.44,5.26.02,6.65,2.96-2.83.56-5.63,1.12-8.43,1.68-.59.12-1.2.15-1.76.35-.95.33-1.28.04-1.52-.94-.45-1.86-.24-3.52.49-5.3,2.26-5.58,4.38-11.21,6.51-16.84.28-.73.68-1.07,1.43-1.2,1.57-.27,3.14-.58,4.69-.92.68-.15.97-.05,1.12.72.98,5.17,2.01,10.33,3.06,15.49.38,1.88.04,1.59,1.93,1.3,1.93-.3,1.43-.71,1.87,1.34.5,2.32.46,2.37-1.85,2.85-.7.14-.85.4-.71,1.03.28,1.29.5,2.58.8,3.87.14.59.06.86-.61.96-1.22.18-2.44.4-3.63.72-.75.2-.96-.03-1.1-.72-.8-4.19-1.64-8.37-2.46-12.56-.5-2.54-1-5.08-1.53-7.79-1.69,4.42-3.32,8.7-4.97,13.01Z"
          />
          <path
            className="cls-1"
            d="m199.61,324.29c2.55,0,5.11.03,7.66-.02.74-.01,1.02.18.9.94-.06.39,0,.8-.01,1.2-.04,2.06.36,1.88-1.82,1.86-3.15-.03-6.31-.14-9.46-.16-.76,0-1.02-.25-.9-.97.03-.2.02-.4.02-.6q.04-2.51,2.53-2.46c.36,0,.72.04,1.08.06,0,.05,0,.1,0,.14Z"
          />
          <path
            className="cls-25"
            d="m332.64,210.83c0,.64.01,1.29.02,1.93-12.23,0-24.46,0-36.69,0q-1.66,0-1.67-1.68c.39-.41.9-.23,1.36-.23,12.33-.01,24.65-.02,36.98-.02Z"
          />
          <path
            className="cls-6"
            d="m242.7,308.64c-.06-2.05.68-3.66,2.59-4.6,1.87-.91,3.65-.61,5.13.71,4.06,3.63,6.39,8.21,6.95,13.63.2,1.99-.61,3.59-2.42,4.58-1.88,1.03-3.64.66-5.24-.6-3-2.36-4.62-5.64-6-9.08-.6-1.49-.97-3.04-1.01-4.65Z"
          />
        </g>
      </g>
    </svg>
  )
);
